import './LowerCardStyle.less';

import { ImgixImg, RadioButtonGroupInput } from '@opendoor/bricks';
import React from 'react';

export interface IOfferDetailFormProps {
  interestedInLower: boolean;
  hasBeenSubmitted: boolean;
  onInterestedInLowerChange: (interestedInLower: boolean) => void;
}

export default class LowerCard extends React.PureComponent<IOfferDetailFormProps> {
  public render(): JSX.Element {
    const { interestedInLower, hasBeenSubmitted, onInterestedInLowerChange } = this.props;
    const LOWER_LOGO = 'https://images.opendoor.com/source/s3/imgdrop-production/54fa3b938eab43a094e246eea5f554e0.png?service=consumer';
    const SAVINGS_ICON = '0f8301252b4b4f0a9be873e34ce23ee4.png';
    const SOLD_ICON = 'f86a2b6a8d6042d88ee4e8ae080d247d.svg';
    const OFFER_ICON = 'a38ec39f4c4f4f2a92607d28d04383cb.svg';

    return (
      <div className="od-offer-detail-form od-base-box box no-padding">
        <div className="top-section less-padding">
          <div className="header">
            <img src={LOWER_LOGO} className="lower-logo" />
            <div className="margin" />
            <p>
              Experience an easier, more certain, and more affordable financing option with
              Opendoor‘s partner lender, Lower.
              <br />
              <br />
              Ready to experience how financing should be?
            </p>
          </div>
          <div className="middle-section">
            <div className="value-prop">
              <div>
                <ImgixImg src={SOLD_ICON} className="image" />
              </div>
              <div className="text">
                <h4>
                  <b>No lender or hidden fees</b>
                </h4>
                <p>Save thousands with no origination, application, or other lender fees.</p>
              </div>
            </div>
            <div className="value-prop">
              <div>
                <ImgixImg src={SAVINGS_ICON} className="image" />
              </div>
              <div className="text">
                <h4>
                  <b>Great rates and up to $7,500 towards closing costs</b>
                </h4>
                <p>Lock-in a competitive rate and get thousands just for using us.</p>
              </div>
            </div>
            <div className="value-prop">
              <div>
                <ImgixImg src={OFFER_ICON} className="image" />
              </div>
              <div className="text">
                <h4>
                  <b>Seamless with no surprises</b>
                </h4>
                <p>
                  We work with you from start to finish to make sure your buyer‘s transaction goes
                  smoothly.
                </p>
              </div>
            </div>
          </div>
          <div className="question-box">
            <div className="question-input">
              <RadioButtonGroupInput
                options={[{ label: '', inputName: 'YesLower', value: 'true' }]}
                onChange={value => onInterestedInLowerChange(true)}
                selectedValue={interestedInLower === null ? null : String(interestedInLower)}
                verticallyAligned={false}
                assertNotNull={hasBeenSubmitted}
              />
            </div>
            <div className="question-text">
              <p>
                <b>YES, contact me about Lower, Opendoor‘s partner lender</b>
              </p>
            </div>
          </div>
          <div className="question-box">
            <div className="question-input">
              <RadioButtonGroupInput
                options={[{ label: '', inputName: 'NoLower', value: 'false' }]}
                onChange={value => onInterestedInLowerChange(false)}
                selectedValue={interestedInLower === null ? null : String(interestedInLower)}
                verticallyAligned={false}
                assertNotNull={hasBeenSubmitted}
              />
            </div>
            <div className="question-text">
              <p>
                <b>NO, not right now</b>
              </p>
            </div>
          </div>
        </div>
        <div className="margin" />
      </div>
    );
  }
}
